import React, { useState } from 'react';
import ImageModal from './ImageModal';

const images = [
  
  
  '/images/m.jpg',
  
  '/images/o.jpg',
  '/images/buildingb.jpeg',
  ,
];

const PictureGallery = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  const openModal = (index) => {
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const showNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-lg shadow-lg h-48 cursor-pointer"
            onClick={() => openModal(index)}
          >
            <img
              src={image}
              alt={`Gallery image ${index + 1}`}
              className="w-full h-full object-contain transform hover:scale-105 transition-transform duration-300"
            />
          </div>
        ))}
      </div>
      <ImageModal
        image={currentImageIndex !== null ? images[currentImageIndex] : null}
        onClose={closeModal}
        onNext={showNextImage}
        onPrev={showPrevImage}
      />
    </div>
  );
};

export default PictureGallery;
